import { render, staticRenderFns } from "./Reviewer.vue?vue&type=template&id=d3582d50&"
import script from "./Reviewer.vue?vue&type=script&lang=js&"
export * from "./Reviewer.vue?vue&type=script&lang=js&"
import style0 from "./Reviewer.vue?vue&type=style&index=0&id=d3582d50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports